var _defs, _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmCategorys = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.825,
    height: 22.825,
    viewBox: "0 0 22.825 22.825",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H22.825V22.825H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.961,3.377,7.423,9.159A.949.949,0,0,0,8.231,10.6H15.3a.949.949,0,0,0,.808-1.446L12.577,3.377a.944.944,0,0,0-1.617,0Z",
    transform: "translate(-0.356 -0.143)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(12.511 12.511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.951,21.108H9.657a.954.954,0,0,0,.951-.951V14.451a.954.954,0,0,0-.951-.951H3.951A.954.954,0,0,0,3,14.451v5.706A.954.954,0,0,0,3.951,21.108Z",
    transform: "translate(-0.147 -0.661)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmCategorys, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admCategorys.0015099a.svg";
export { ForwardRef as ReactComponent };